import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
export function Guarantee() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-100" data-mp="20mei7nt9x04e">
      <div className="mx-auto max-w-2xl" data-id="element-101" data-mp="24n882mqa0ozx">
        <Reveal data-id="element-102" data-mp="24m5do4tqw4f9">
          <div className="rounded-3xl border border-sand-line bg-cream-card px-6 py-10 text-center sm:px-12 sm:py-12" data-id="element-103" data-mp="24ln82hl70duo">
            <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-olive-soft text-olive" data-id="element-104" data-mp="29g17cv2z754m">
              <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-105" data-mp="2jbukafklx0mx" />
            </span>

            <h2 className="mt-5 font-display text-4xl leading-tight text-cocoa sm:text-5xl" data-id="element-106" data-mp="2ob7hnu93tq3r">Garantía de 7 días</h2>
            <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-cocoa-soft sm:text-base" data-id="element-107" data-mp="2scj27ld4fl53">
              Queremos que puedas acceder al material y revisarlo con tranquilidad. Por eso tu compra está respaldada
              por una <strong className="font-bold text-cocoa" data-id="element-108" data-mp="xzjcv0ixvckm">garantía de 7 días</strong>.
            </p>
            <p className="mx-auto mt-4 max-w-md text-xs leading-relaxed text-cocoa-dim" data-id="element-109" data-mp="3smhumd595dtu">
              Consultá las condiciones aplicables al momento de realizar tu compra.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}